var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-card',{staticClass:"mt-4"},[_c('v-card-title',{staticClass:"pt-2 px-2 accent--text display-2"},[_vm._v(" BFIT "),_c('span',{staticClass:"silver--text body-1 mt-n6 ml-1"},[_vm._v("R")]),_c('v-divider',{staticClass:"accent lighten-4 ml-n3"})],1),_c('FirstTime')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }